import { normalizeText } from '@theme/utils/normalize-text';

export const COMPARE_CATEGORY_KEY = 'category-karsilastirma';

export interface CompareField {
  label: string;
  attribute_key: string;
  format?: string;
}

export const toCompareWidgetKey = (category: string): string =>
  normalizeText(category)
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');

export const resolveCompareFields = (
  widgetData: { attributes?: Record<string, { value?: CompareField }[]>; } | undefined,
  category: string | undefined
): CompareField[] => {
  if (!widgetData || !category) return [];

  return (widgetData.attributes?.[toCompareWidgetKey(category)] ?? [])
    .map((entry) => entry.value)
    .filter((field) => field?.attribute_key);
};

export const isDifferentCompareCategory = (
  product: { attributes?: Record<string, unknown> } | undefined | null,
  compareCategory: string
): boolean =>
  !!compareCategory &&
  product?.attributes?.[COMPARE_CATEGORY_KEY] !== compareCategory;

export const hasCompareValue = (value: unknown): boolean =>
  value !== undefined &&
  value !== null &&
  String(value).trim() !== '' &&
  String(value).trim() !== '-';

export const splitListValue = (value: unknown): string[] =>
  String(value ?? '')
    .split(';')
    .map((item) => item.trim())
    .filter(Boolean);
